'use client';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SelectedPlanExpander from './SelectedPlanExpander';
import { useCheckout } from '@stripe/react-stripe-js/checkout';
import ProductExpander from './ProductExpander';
import { Stripe } from 'stripe';
import LineItem from './LineItem';

const SelectedPlanCard = ({
  // product,
  lineItems,
  onChangeLink
}: {
  // product: StripeProductWithPrice;
  lineItems?: StripeLineItemWithPriceProduct[];
  onChangeLink?: () => string | undefined;
}) => {
  const checkoutState = useCheckout();
  const checkout =
    checkoutState.type === 'success' ? checkoutState.checkout : null;

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  console.log('lineItems in SelectedPlanCard:', lineItems);

  return lineItems ? (
    <LineItem
      lineItem={lineItems[0]}
      initialExpanded={!isMobile}
      disableExpand={!isMobile}
    />
  ) : null;

  // if (product.default_price.recurring)
  //   return (
  //     <SelectedPlanExpander
  //       product={product}
  //       initialExpanded={!isMobile}
  //       disableExpand={!isMobile}
  //       onChangeLink={onChangeLink ? onChangeLink() : undefined}
  //     />
  //   );

  // return (
  //   <ProductExpander
  //     product={{
  //       name: checkout?.lineItems[0].name || '',
  //       description: checkout?.lineItems[0].description || '',
  //       price: checkout?.lineItems[0].subtotal.amount || '0'
  //     }}
  //     initialExpanded={!isMobile}
  //     disableExpand={!isMobile}
  //   />
  // );
};

export default SelectedPlanCard;
